import { combineReducers } from '@reduxjs/toolkit';
import { all, fork } from 'redux-saga/effects';
import storelocatorSaga from './storelocator.saga';
import storelocatorSlice from './storelocator.slice';
export const storelocatorReducer = combineReducers({
    storelocator: storelocatorSlice.reducer,
});
export function* storelocatorRootSaga() {
    yield all([fork(storelocatorSaga)]);
}
